module.exports = __webpack_public_path__ + "static/media/Children and Dog - Charcoal.060cdc3b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/Children and Dog - Charcoal.jpg
 ** module id = 390
 ** module chunks = 0
 **/